import DynamicForm from "components/DynamicForm";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Row, Col, Container, Alert, Spinner } from "react-bootstrap";
import { bankVerification } from "api/dashboardDetail";
import Toast from "components/ToastComponent";
import { v4 as uuidv4 } from "uuid";
import GreenTick from "../../../src/assets/images/Group 28410@2x.png";

const VerificationGroup = (props) => {
  const {
    setSelectedData,
    selectedData,
    handleNext,
    formErr,
    setFormErr,
    clearFieldError,
    className,
    verificationFields,
    verifiedText,
    formFields
  } = props;


  const [orgId, setOrgId] = useState("");
  const [subWfId, setSubWfId] = useState("");
  const [response, setResponse] = useState(false);
  const [loading, setLoading] = useState(false)
  const [disableStatus, setDisableStatus] = useState(false)

  const dispatch = useDispatch();

  const organisationId = useSelector(
    (state) => state?.configurationReducer?.config
  );

  const sub_id = useSelector((state) => state.urlEncryption?.urlId);
  const is_verified = useSelector((state) => state.formData?.selectedData);
  const formData = useSelector((state) => state?.formData?.selectedData);
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const primary_workflow_id = decryptedId?.primary_workflow_id;

  useEffect(() => {
    if (organisationId && organisationId?.organisation_id) {
      setOrgId(organisationId?.organisation_id);
    }
  }, [organisationId]);

  useEffect(() => {
    if(sub_id && sub_id?.subWfId) {
      setSubWfId(sub_id?.subWfId)
    }
  }, [sub_id])

  const [toastMessage, setToastMessage] = useState({
    status: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if(formData?.bank_account_number && formData?.ifsc_code) {
      if((formData?.bank_account_number != formData?.verified_bank_account) || (formData?.ifsc_code != formData?.verified_ifsc_code)) {
        setDisableStatus(true)
      }
    }
  }, [formData?.bank_account_number, formData?.ifsc_code])

  const handleVerify = async (item) => {
    setLoading(true)

    const verificationParams = {
      subwfId: subWfId,
      verificationType: item?.type,
      organisation_id: orgId,
      reference_id: uuidv4().replace(/-/g, ""),
      account_number: selectedData?.bank_account_number,
      ifsc: selectedData?.ifsc_code,
      primary_workflow_id : primary_workflow_id
    };

    const response = await dispatch(bankVerification(verificationParams)).unwrap();


    if (response?.status == "success") {
      setResponse(true);
      setLoading(false);
      setDisableStatus(!disableStatus)
      setToastMessage({
        status: true,
        type: "success",
        message: response?.message,
      });
      if(!item?.bank_verified){
        dispatch(setSelectedData({key: 'bank_verified', value: true}))
        dispatch(setSelectedData({key: 'verified_bank_account', value: formData?.bank_account_number }))
        dispatch(setSelectedData({key: 'verified_ifsc_code', value: formData?.ifsc_code }))
      }
    }
    if (response?.status == "failed") {
      setLoading(false)
      setToastMessage({
        status: true,
        type: "error",
        message: response?.error,
      });
      dispatch(setSelectedData({ key: 'bank_verified', value: false }));
    }
    setTimeout(() => {
      setToastMessage(null);
    }, 3000);
  };
  return (
    <>
      {toastMessage?.status && (
        <Toast
          type={toastMessage?.type}
          message={toastMessage?.message}
          autoClose={3000}
        />
      )}
      <div className={`group_container ${className}`}>
        {(is_verified?.bank_verified ? !disableStatus : false  ) && (
          <Alert
            variant="success"
            className="mt-2 p-2"
            style={{ marginBottom: "-10px" }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>{verifiedText}</div>
              <div>
                <img
                  style={{ width: "30px", height: "30px" }}
                  src={GreenTick}
                />
              </div>
            </div>
          </Alert>
        )}

        <Row>
          <Col>
            {formFields &&
              formFields?.map((item, i) => {
                return (
                  <Fragment key={i}>
                    <DynamicForm
                      formErr={formErr}
                      setFormErr={setFormErr}
                      clearFieldError={clearFieldError}
                      formFields={item}
                      handleNext={handleNext}
                      selectedData={selectedData}
                      setSelectedData={setSelectedData}
                    />
                  </Fragment>
                );
              })}
          </Col>
        </Row>
        {verificationFields &&
          verificationFields?.map((item, i) => {
            return (
              <Row>
                <Col className={`${item?.custom_style}`}>
                  {eval(item?.show) && !loading &&(
                    <Button 
                      onClick={() => handleVerify(item)}
                      disabled={disableStatus ? false :  is_verified?.bank_verified}
                      >
                      {item?.label}
                    </Button>
                  )}
                  {loading  && (
                    <Button variant="primary" disabled>
                      <Spinner className="me-2" as='span' animation="border" size="sm" role="status" aria-hidden='true' />
                      Verifying..
                    </Button>
                  )}
                </Col>
              </Row>
            );
          })}
      </div>
    </>
  );
};

export default VerificationGroup;
